module.exports = __webpack_public_path__ + "img/logo-startup.38937558.svg";